export default function Background(props) {
  let viewBoxX = props.court.full ? 10 * -1 : (props.court.width / 2 + 10) * -1;
  let viewBoxY = props.court.full ? (props.court.width / 2 + 10) * -1 : 10 * -1;
  let viewBoxWidth = props.court.full ? props.court.length + 2 * 10 : props.court.width + 2 * 10;
  let viewBoxHeight = props.court.full ? props.court.width + 2 * 10 : (props.court.length + 2 * 10) / 2;

  if (props)
    return (
      <svg
        version="1.1"
        x={viewBoxX}
        y={viewBoxY}
        xmlSpace="preserve"
        preserveAspectRatio="xMinYMin slice"
        width={viewBoxWidth}
        height={viewBoxHeight}
        viewBox={'0 0 5280 4000'}
        xmlns="http://www.w3.org/2000/svg">

        <rect width={5280} height={4000} x={0} y={0} fill={props.courtColor.backgroundColor} />
        {props.courtColor.showTiles && (
          <g style={{transformOrigin:"2640px 2000px",transform: props.court.full ? "rotate(90deg) scale(1.4)" :undefined }}>
          <g transform="matrix(1.3333333,0,0,-1.3333333,0,2640) ">
            <g transform="matrix(0,-0.1,0.1,0,0,1980)">
              <path
                d="m 0,19200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path14"
              />
              <path
                d="M 20340.7,19200.1 H 30000 v 600 h -9659.3 z"
                style={{fill: '#c89742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path16"
              />
              <path
                d="m 0,18600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c98a28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path18"
              />
              <path
                d="m 0,18600.1 h 9260.69 v 600 H 0 Z"
                style={{fill: '#c49245', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path20"
              />
              <path
                d="m 0,18000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path22"
              />
              <path
                d="m 0,17400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path24"
              />
              <path
                d="M 16560.7,17400.1 H 30000 v 600 H 16560.7 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path26"
              />
              <path
                d="m 0,16800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path28"
              />
              <path
                d="m 11100,16800.1 h 13800 v 600 H 11100 Z"
                style={{fill: '#da9f3b', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path30"
              />
              <path
                d="m 0,16200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path32"
              />
              <path
                d="m 0,16200.1 h 7040.69 v 600 H 0 Z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path34"
              />
              <path
                d="m 0,15600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cf8f31', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path36"
              />
              <path
                d="m 0,15600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path38"
              />
              <path
                d="m 0,15000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path40"
              />
              <path
                d="m 11280.3,15000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path42"
              />
              <path
                d="m 0,14400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path44"
              />
              <path
                d="m 7920.69,14400.1 h 9000.01 v 600 H 7920.69 Z"
                style={{fill: '#cc9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path46"
              />
              <path
                d="m 0,13800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path48"
              />
              <path
                d="m 0,13200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path50"
              />
              <path
                d="M 20840.7,13200.1 H 30000 v 600 h -9159.3 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path52"
              />
              <path
                d="m 0,13200.1 h 8095.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path54"
              />
              <path
                d="m 0,12600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88f39', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path56"
              />
              <path
                d="m 0,12600.1 h 11690.7 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path58"
              />
              <path
                d="m 0,12000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path60"
              />
              <path
                d="m 15900,12000.1 h 12000 v 600 H 15900 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path62"
              />
              <path
                d="m 0,11400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path64"
              />
              <path
                d="m 10200,11400.1 h 12000 v 600 H 10200 Z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path66"
              />
              <path
                d="m 0,10800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path68"
              />
              <path
                d="m 0,10800.1 h 2620.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path70"
              />
              <path
                d="m 0,10200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path72"
              />
              <path
                d="M 22220.7,10200.1 H 30000 v 600 h -7779.3 z"
                style={{fill: '#c5832d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path74"
              />
              <path
                d="m 0,9600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19f48', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path76"
              />
              <path
                d="m 0,9600.1 h 12500.7 v 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path78"
              />
              <path
                d="m 0,9000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path80"
              />
              <path
                d="m 13700.7,9000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c48f3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path82"
              />
              <path
                d="m 0,8400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path84"
              />
              <path
                d="m 0,8400.1 h 8120.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path86"
              />
              <path
                d="m 0,7800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path88"
              />
              <path
                d="M 25168.2,7800.1 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c88f37', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path90"
              />
              <path
                d="m 0,7200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path92"
              />
              <path
                d="m 0,6600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path94"
              />
              <path
                d="m 8100,6600.1 h 10200 v 600 H 8100 Z"
                style={{fill: '#cf9a3f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path96"
              />
              <path
                d="m 0,6000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path98"
              />
              <path
                d="M 21290.7,6000.1 H 30000 v 600 h -8709.3 z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path100"
              />
              <path
                d="m 0,5400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d7a246', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path102"
              />
              <path
                d="m 0,5400.1 h 13140.7 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path104"
              />
              <path
                d="m 0,4800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path106"
              />
              <path
                d="M 24770.7,4800.1 H 30000 v 600 h -5229.3 z"
                style={{fill: '#ce9742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path108"
              />
              <path
                d="m 0,4200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path110"
              />
              <path
                d="m 0,3600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19740', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path112"
              />
              <path
                d="m 0,3600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca913c', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path114"
              />
              <path
                d="m 0,3000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path116"
              />
              <path
                d="M 21850.3,3000.1 H 30000 v 600 h -8149.7 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path118"
              />
              <path
                d="m 0,2400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path120"
              />
              <path
                d="M 13700.7,2400.1 H 30000 v 600 H 13700.7 Z"
                style={{fill: '#cb8d3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path122"
              />
              <path
                d="m 0,1800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path124"
              />
              <path
                d="m 10500,1800.1 h 9000 v 600 h -9000 z"
                style={{fill: '#ce9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path126"
              />
              <path
                d="m 0,1200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path128"
              />
              <path
                d="m 0,1200.1 h 6210.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path130"
              />
              <path
                d="m 0,600.102 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path132"
              />
              <path
                d="M 25168.2,600.102 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c37e28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path134"
              />
              <path
                d="M 0,0.101563 H 30000 V 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path136"
              />
              <path
                d="M 0,0.101563 H 12420.7 V 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path138"
              />
            </g>
            <g id="g12-7" transform="matrix(0,-0.1,0.1,0,1979.9899,1980)">
              <path
                d="m 0,19200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path14-0"
              />
              <path
                d="M 20340.7,19200.1 H 30000 v 600 h -9659.3 z"
                style={{fill: '#c89742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path16-0"
              />
              <path
                d="m 0,18600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c98a28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path18-1"
              />
              <path
                d="m 0,18600.1 h 9260.69 v 600 H 0 Z"
                style={{fill: '#c49245', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path20-0"
              />
              <path
                d="m 0,18000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path22-3"
              />
              <path
                d="m 0,17400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path24-0"
              />
              <path
                d="M 16560.7,17400.1 H 30000 v 600 H 16560.7 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path26-0"
              />
              <path
                d="m 0,16800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path28-3"
              />
              <path
                d="m 11100,16800.1 h 13800 v 600 H 11100 Z"
                style={{fill: '#da9f3b', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path30-8"
              />
              <path
                d="m 0,16200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path32-3"
              />
              <path
                d="m 0,16200.1 h 7040.69 v 600 H 0 Z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path34-6"
              />
              <path
                d="m 0,15600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cf8f31', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path36-0"
              />
              <path
                d="m 0,15600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path38-4"
              />
              <path
                d="m 0,15000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path40-0"
              />
              <path
                d="m 11280.3,15000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path42-9"
              />
              <path
                d="m 0,14400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path44-2"
              />
              <path
                d="m 7920.69,14400.1 h 9000.01 v 600 H 7920.69 Z"
                style={{fill: '#cc9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path46-4"
              />
              <path
                d="m 0,13800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#ca8c2f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path48-9"
              />
              <path
                d="m 0,13200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path50-2"
              />
              <path
                d="M 20840.7,13200.1 H 30000 v 600 h -9159.3 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path52-9"
              />
              <path
                d="m 0,13200.1 h 8095.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path54-1"
              />
              <path
                d="m 0,12600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88f39', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path56-0"
              />
              <path
                d="m 0,12600.1 h 11690.7 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path58-9"
              />
              <path
                d="m 0,12000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path60-3"
              />
              <path
                d="m 15900,12000.1 h 12000 v 600 H 15900 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path62-0"
              />
              <path
                d="m 0,11400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path64-0"
              />
              <path
                d="m 10200,11400.1 h 12000 v 600 H 10200 Z"
                style={{fill: '#c89240', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path66-3"
              />
              <path
                d="m 0,10800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path68-0"
              />
              <path
                d="m 0,10800.1 h 2620.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path70-1"
              />
              <path
                d="m 0,10200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path72-9"
              />
              <path
                d="M 22220.7,10200.1 H 30000 v 600 h -7779.3 z"
                style={{fill: '#c5832d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path74-8"
              />
              <path
                d="m 0,9600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19f48', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path76-6"
              />
              <path
                d="m 0,9600.1 h 12500.7 v 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path78-9"
              />
              <path
                d="m 0,9000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path80-0"
              />
              <path
                d="m 13700.7,9000.1 h 12000 v 600 h -12000 z"
                style={{fill: '#c48f3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path82-1"
              />
              <path
                d="m 0,8400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path84-6"
              />
              <path
                d="m 0,8400.1 h 8120.69 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path86-4"
              />
              <path
                d="m 0,7800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path88-4"
              />
              <path
                d="M 25168.2,7800.1 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c88f37', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path90-8"
              />
              <path
                d="m 0,7200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#daa549', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path92-6"
              />
              <path
                d="m 0,6600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path94-1"
              />
              <path
                d="m 8100,6600.1 h 10200 v 600 H 8100 Z"
                style={{fill: '#cf9a3f', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path96-4"
              />
              <path
                d="m 0,6000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path98-0"
              />
              <path
                d="M 21290.7,6000.1 H 30000 v 600 h -8709.3 z"
                style={{fill: '#d49d44', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path100-8"
              />
              <path
                d="m 0,5400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d7a246', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path102-1"
              />
              <path
                d="m 0,5400.1 h 13140.7 v 600 H 0 Z"
                style={{fill: '#c88d32', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path104-0"
              />
              <path
                d="m 0,4800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path106-3"
              />
              <path
                d="M 24770.7,4800.1 H 30000 v 600 h -5229.3 z"
                style={{fill: '#ce9742', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path108-1"
              />
              <path
                d="m 0,4200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path110-1"
              />
              <path
                d="m 0,3600.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d19740', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path112-5"
              />
              <path
                d="m 0,3600.1 h 13260.7 v 600 H 0 Z"
                style={{fill: '#ca913c', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path114-0"
              />
              <path
                d="m 0,3000.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d8a651', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path116-8"
              />
              <path
                d="M 21850.3,3000.1 H 30000 v 600 h -8149.7 z"
                style={{fill: '#c78925', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path118-4"
              />
              <path
                d="m 0,2400.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d3a24a', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path120-9"
              />
              <path
                d="M 13700.7,2400.1 H 30000 v 600 H 13700.7 Z"
                style={{fill: '#cb8d3d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path122-3"
              />
              <path
                d="m 0,1800.1 h 30000 v 600 H 0 Z"
                style={{fill: '#cd9d4e', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path124-0"
              />
              <path
                d="m 10500,1800.1 h 9000 v 600 h -9000 z"
                style={{fill: '#ce9844', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path126-5"
              />
              <path
                d="m 0,1200.1 h 30000 v 600 H 0 Z"
                style={{fill: '#d6a447', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path128-2"
              />
              <path
                d="m 0,1200.1 h 6210.35 v 600 H 0 Z"
                style={{fill: '#cc9338', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path130-3"
              />
              <path
                d="m 0,600.102 h 30000 v 600 H 0 Z"
                style={{fill: '#c48930', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path132-8"
              />
              <path
                d="M 25168.2,600.102 H 30000 v 600 h -4831.8 z"
                style={{fill: '#c37e28', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path134-7"
              />
              <path
                d="M 0,0.101563 H 30000 V 600 H 0 Z"
                style={{fill: '#ce943d', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path136-8"
              />
              <path
                d="M 0,0.101563 H 12420.7 V 600 H 0 Z"
                style={{fill: '#d19d47', fillOpacity: 1, fillRule: 'nonzero', stroke: 'none'}}
                id="path138-0"
              />
            </g>
            <rect
            style={{fill: 'rgb(240,225,205)', fillOpacity: '0.6'}}
          //   style={{fill: '#fff', fillOpacity: '0.45'}}

              id="rect61026"
              width={3960}
              height={3100}
              x="-14.831265"
              y="-1991.865"
              transform="scale(1,-1)"
            />
          </g>
          </g>
        )}
      </svg>
    );
}
